<a href="{{ url }}" ycnTooltip [tooltipPlacement]="'bottom'" [tooltipTitle]="tooltipContent">{{ name }}</a>